import React from 'react'

import { FormSection } from 'redux-form'

import { makeDefaultItem } from '../../../util/jsonSchema'
import { H4, Button } from '../../../components/index'
import SchemaForm from './SchemaObject'

const SchemaFormArray = ({ fields, prop, ...props }) => {
  return (
    <div className='bg-white mt2-sm mb2-sm p4-sm'>
      <div className='flex-container pb5-md'>
        <H4 className='flex-fill u-bold'>{prop.title}</H4>
        {props.invalid && <div className='ncss-error-msg' key='error'>{props.error}</div>}
        <Button onClick={() => fields.push({ _include: true, ...makeDefaultItem(prop.items) })}><i className='g72-plus-large' /> Add</Button>
      </div>
      {
        fields.map((member, index) => {
          return (
            <div className='mb3-sm p5-md border-top' key={index}>
              <div className='flex-container fl-md-r'>
                <Button color='white' onClick={() => fields.remove(index)}>
                  <i className='g72-x-thick text-color-error' />
                </Button>
              </div>
              <div className='ncss-col-md-10'>
                <FormSection name={member}>
                  <SchemaForm schema={prop.items} />
                </FormSection>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default SchemaFormArray



// WEBPACK FOOTER //
// ./client/src/serviceDesk/request/forms/SchemaArray.js